import { audio } from '../lib/audio.js';
import type { AbilityName } from '../world/types.js';

interface InputState {
  keys: Record<string, boolean>;
  joyVec: { x: number; y: number };
}

// Single shared input state, mutated by the various input modules.
export const input: InputState = {
  keys: {},
  joyVec: { x: 0, y: 0 },
};

export interface InputHandlers {
  onAbility: (name: AbilityName) => void;
  onReset: () => void;
  onMuteToggle?: () => void;
  onBackToMenu?: () => void;
}

const ABILITY_KEYS: Record<string, AbilityName> = {
  KeyQ: 'box',
  KeyE: 'knock',
  KeyF: 'decoy',
  KeyH: 'hack',
  Space: 'takedown',
};

export function setupKeyboard(handlers: InputHandlers): void {
  addEventListener('keydown', (e) => {
    // First user gesture → unlock the AudioContext (Chrome/Safari autoplay policy)
    audio.unlock();

    input.keys[e.code] = true;
    const ab = ABILITY_KEYS[e.code];
    if (ab) {
      handlers.onAbility(ab);
      if (e.code === 'Space') e.preventDefault();
    } else if (e.code === 'KeyR') {
      handlers.onReset();
    } else if (e.code === 'KeyM') {
      handlers.onMuteToggle?.();
    } else if (e.code === 'Escape') {
      handlers.onBackToMenu?.();
    }
  });
  addEventListener('keyup', (e) => {
    input.keys[e.code] = false;
  });
}
